module.exports = __webpack_public_path__ + "static/img/MPcon1@2x.6a43d479.png";